module.exports = __webpack_public_path__ + "img/t2.cebd5c25.png";